import React from 'react';
import './Slideshow.css';

const notes = [
  'Verified growers can present their stock clearly.',
  'Buyers can search by plant, location, and seller profile.',
  'Conversations stay close to the product being discussed.',
];

const Slideshow = () => {
  return (
    <section className="ankurit-proof" id="gallery">
      <div className="ankurit-proof__image">
        <img src="/pictures/nursery.jpg" alt="A plant nursery with rows of healthy saplings" />
      </div>

      <div className="ankurit-proof__content">
        <span>Built for the field</span>
        <h2>Less friction between healthy stock and real demand.</h2>
        <p>
          The homepage should say one thing well: Ankurit is a practical
          marketplace for nursery plants, farmers, and buyers who need a simpler
          way to find each other.
        </p>

        <ul>
          {notes.map((note) => (
            <li key={note}>{note}</li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Slideshow;
